/* ========================================
   Brand Hero + Product Panel
   Colour / size selection, price and stock state, add to bag.
   ======================================== */

(function () {
  'use strict';

  function init(section) {
    if (!section || section.hasAttribute('data-brand-hero-ready')) return;
    section.setAttribute('data-brand-hero-ready', 'true');

    var variants = readJSON(section.querySelector('[data-hero-variants]')) || [];
    if (!variants.length) return;

    var colorPos = parseInt(section.getAttribute('data-color-position'), 10) || 0;
    var sizePos = parseInt(section.getAttribute('data-size-position'), 10) || 0;

    var form = section.querySelector('form');
    var variantInput = section.querySelector('[data-hero-variant-input]');
    var priceEl = section.querySelector('[data-hero-price]');
    var colorLabel = section.querySelector('[data-hero-selected-color]');
    var addBtn = section.querySelector('[data-hero-add]');
    var note = section.querySelector('[data-hero-note]');
    var swatches = toArray(section.querySelectorAll('[data-hero-swatch]'));
    var sizeBtns = toArray(section.querySelectorAll('[data-hero-size]'));

    var selectedColor = null;
    var selectedSize = null;

    var preselected = swatches.filter(function (b) { return b.classList.contains('is-selected'); })[0];
    if (preselected) selectedColor = preselected.getAttribute('data-value');

    function optionOf(variant, pos) {
      if (pos === 1) return variant.option1;
      if (pos === 2) return variant.option2;
      if (pos === 3) return variant.option3;
      return null;
    }

    function matching() {
      return variants.filter(function (v) {
        if (colorPos && selectedColor !== null && optionOf(v, colorPos) !== selectedColor) return false;
        if (sizePos && selectedSize !== null && optionOf(v, sizePos) !== selectedSize) return false;
        return true;
      });
    }

    // Grey out sizes with no stock in the chosen colour.
    function refreshSizes() {
      if (!sizePos) return;
      sizeBtns.forEach(function (btn) {
        var value = btn.getAttribute('data-value');
        var available = variants.some(function (v) {
          if (optionOf(v, sizePos) !== value) return false;
          if (colorPos && selectedColor !== null && optionOf(v, colorPos) !== selectedColor) return false;
          return v.available;
        });
        btn.disabled = !available;
        if (!available && btn.classList.contains('is-selected')) {
          btn.classList.remove('is-selected');
          selectedSize = null;
        }
      });
    }

    function currentVariant() {
      var candidates = matching();
      if (!candidates.length) return null;
      // A full selection resolves to one variant; a partial one is not yet buyable.
      if (sizePos && selectedSize === null) return null;
      if (colorPos && selectedColor === null) return null;
      return candidates[0];
    }

    function refresh() {
      refreshSizes();

      var variant = currentVariant();
      if (variant) {
        if (variantInput) variantInput.value = variant.id;
        if (priceEl && variant.price) priceEl.textContent = variant.price;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available
            ? (addBtn.getAttribute('data-label') || addBtn.textContent)
            : 'Sold out';
        }
        setNote('');
      } else if (addBtn) {
        addBtn.disabled = false;
      }

      // Price for a colour with no size chosen yet: show that colour's cheapest.
      if (!variant && priceEl && colorPos && selectedColor !== null) {
        var forColor = variants.filter(function (v) {
          return optionOf(v, colorPos) === selectedColor && v.available;
        });
        if (forColor.length && forColor[0].price) priceEl.textContent = forColor[0].price;
      }
    }

    // Crossfade the hero photo to the chosen colour's layer (CSS does the fade).
    // Colours without their own layer fall back to the main images.
    var layers = toArray(section.querySelectorAll('[data-hero-layer]'));

    function showColourImage(colour) {
      if (layers.length < 2) return;
      var key = String(colour || '').toLowerCase().trim();
      var target = layers.filter(function (l) { return l.getAttribute('data-colour') === key; })[0] ||
        layers.filter(function (l) { return l.getAttribute('data-colour') === ''; })[0];
      if (!target) return;
      layers.forEach(function (l) { l.classList.toggle('is-active', l === target); });
    }

    function setNote(message) {
      if (note) note.textContent = message || '';
    }

    swatches.forEach(function (btn) {
      if (addBtn && !addBtn.getAttribute('data-label')) {
        addBtn.setAttribute('data-label', addBtn.textContent.trim());
      }
      btn.addEventListener('click', function () {
        selectedColor = btn.getAttribute('data-value');
        swatches.forEach(function (o) { o.classList.toggle('is-selected', o === btn); });
        if (colorLabel) colorLabel.textContent = selectedColor;
        showColourImage(selectedColor);
        refresh();
      });
    });

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        selectedSize = btn.getAttribute('data-value');
        sizeBtns.forEach(function (o) { o.classList.toggle('is-selected', o === btn); });
        refresh();
      });
    });

    if (addBtn && !addBtn.getAttribute('data-label')) {
      addBtn.setAttribute('data-label', addBtn.textContent.trim());
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (sizePos && selectedSize === null) {
          event.preventDefault();
          setNote('Please choose a size.');
          return;
        }
        if (colorPos && selectedColor === null) {
          event.preventDefault();
          setNote('Please choose a colour.');
          return;
        }

        // Without the cart drawer (e.g. its script failed to load), let the
        // form post to /cart as normal rather than leave the button dead.
        if (!hasCartDrawer()) return;

        event.preventDefault();
        addToBag();
      });
    }

    // ---- Add to bag via the cart drawer (same flow as product.js) ----

    var adding = false;

    function addToBag() {
      if (adding) return;
      var id = variantInput ? Number(variantInput.value || 0) : 0;
      if (!id) {
        setNote('Please choose a size.');
        return;
      }

      adding = true;
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
      }
      setNote('');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            if (!res.ok) {
              // Shopify explains stock refusals in `description`,
              // e.g. "All 2 ... are in your cart."
              var err = new Error('add failed');
              err.userMessage = data && (data.description || data.message);
              throw err;
            }
            return data;
          });
        })
        .then(function (added) {
          refreshCartCount();
          dispatchCartEvents({ source: 'brand-hero', added: added });
          window.CartDrawer.open();
        })
        .catch(function (err) {
          setNote((err && err.userMessage) || "Sorry, we couldn't add to bag.");
        })
        .then(function () {
          adding = false;
          if (addBtn) addBtn.textContent = addBtn.getAttribute('data-label') || 'Add to bag';
          refresh();
        });
    }

    function hasCartDrawer() {
      return !!(window.CartDrawer && typeof window.CartDrawer.open === 'function');
    }

    function dispatchCartEvents(detail) {
      try {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail || {} }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail || {} }));
      } catch (e) {}
    }

    // Header bag count — same selectors product.js updates.
    function refreshCartCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var selectors = '[data-cart-count], [data-cart-count-badge], .cart-count, .cart-count-badge';
          toArray(document.querySelectorAll(selectors)).forEach(function (el) {
            el.textContent = String(cart.item_count || 0);
          });
        })
        .catch(function () {});
    }

    refresh();
  }

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes);
  }

  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || 'null');
    } catch (e) {
      return null;
    }
  }

  function boot() {
    toArray(document.querySelectorAll('[data-brand-hero]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-brand-hero]');
    if (section) init(section);
  });
})();
